import FeedLayout from "layouts/files/FeedLayout";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Button, PasswordInput, SVG } from "ui";

const DeleteAccount = () => {
    const [pswd, setPswd] = useState("");
    // const [pswdErr, setPswdErr] = useState("");

    return (
        <FeedLayout pageTitle="Settings">
            <div className="settings-page account-info-page">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/settings/account">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Delete your Account</h1>
                    <div></div>
                </div>

                <div className="community-info community-info-fields delete-account-field card d-flex flex-col flex-j-between flex-a-center">
                    <div>
                        <div className="highlight-text">
                            <h2 className="red-text">
                                deleting your account is permenant
                            </h2>
                            <p>
                                Your profile, photos, videos, comments, likes,
                                and followers will be permanently deleted
                            </p>
                        </div>
                        {/* new pswd */}
                        <PasswordInput
                            value={pswd}
                            handleChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                            ) => setPswd(e.target.value)}
                            label="Please enter password to confirm deleting your account"
                            error={""}
                        />
                    </div>

                    <div className="d-flex flex-j-center flex-a-center w-full mt-auto">
                        <Button text="Delete" color="red-button" rounded />
                    </div>
                </div>
            </div>
        </FeedLayout>
    );
};

export default DeleteAccount;
